<template>
  <div class="map" id="member-map"></div>
</template>

<script>

  import {whereToStayIcon, thingsToDoIcon, eatAndDrinkIcon, festivalsIcon, mapOptions} from '../../../../src/components/03-ui/44-maps/map-helpers.js';

  export default {
    name: 'gmap',

    props: {
      members: {
        type: Array,
      }
    },

    data () {
      return {
        // this will be the Google Map object itself
        map: {},
        // infowindow: null,
        markers: [],
        markerCluster: null,

        categoryCollection: ''
        // coverImage: null,
        // infowindowImage: null,
      }
    },

    watch: {
      members () {
        this.clearMarkers();
        this.setupMarkers();
      }
    },

    mounted () {
      /* eslint-disable no-undef */
      this.createMap();
      this.setupMarkers();

      // when the bounds change from panning/zooming, we'll debounce it a bit
      // this.map.addListener('bounds_changed', debounce(this.handleBoundsChanged, 500))
    },

    methods: {
      handleMarkerClick () {
        this.infowindow.open(this.map, this.marker)
      },

      createMap () {
        /* eslint-disable no-undef */
        this.map = new google.maps.Map(this.$el, {
          // List of map params here: https://developers.google.com/maps/documentation/javascript/examples/control-options

          options: mapOptions,
          // You can attribute an array of styles if you wish, either manually or via snazzymaps
          center: new google.maps.LatLng(52.259896, -7.105771) // doesn't really matter where this is, fitBounds will update the view
        });
      },

      setupMarkers () {
        // Declare blank mapwide infowindow
        this.infowindow = new google.maps.InfoWindow();

        // Loop through the members to add them to the map
        let allMembers = this.members.map(member => {

          let markerLatitude = parseFloat(52.259896);
          let markerLongitude = parseFloat(-7.105771);

          // Setup Marker Args
          if ( member.member_location ) {
            if(member.member_location.lat) {
              markerLatitude = parseFloat(member.member_location.lat);
            }

            if(member.member_location.lng){
              markerLongitude = parseFloat(member.member_location.lng);
            }

            if (!member.member_location.lat) {
              console.log ("This entry does not have valid map coordinates. (A) Please login to the CMS and rectify this: " + member.title);
            }
          } else {
            console.log ("This entry does not have valid map coordinates. (B) Please login to the CMS and rectify this: " + member.title);
          }

          let latlng = new google.maps.LatLng(markerLatitude, markerLongitude);

          // Create New Marker
          let marker = new google.maps.Marker({
            position: latlng
          });

          // Map this members categories, check what they are and assign the appropriate marker icon
          if (member.categories) {
            member.categories.map(cat => {

              if ( cat.slug === "where-to-stay" ) {
                marker.setIcon(whereToStayIcon);
              }

              if ( cat.slug === "things-to-do" ) {
                marker.setIcon(thingsToDoIcon);
              }

              if ( cat.slug === "eat-drink" ) {
                marker.setIcon(eatAndDrinkIcon);
              }

              if ( cat.slug === "festival" ) {
                marker.setIcon(festivalsIcon);
              }
            });
          }

          if (member.types) {
            member.types.map(type => {

              if ( type.slug === "where-to-stay" ) {
                marker.setIcon(whereToStayIcon);
              }

              if ( type.slug === "things-to-do" ) {
                marker.setIcon(thingsToDoIcon);
              }

              if ( type.slug === "eat-drink" ) {
                marker.setIcon(eatAndDrinkIcon);
              }

              if ( type.slug === "festival" ) {
                marker.setIcon(festivalsIcon);
              }
            });
          }

          // Add this marker to the map
          marker.setMap(this.map);

          // Add this marker to array of markers
          this.markers.push( marker );

          // this.getImageUrl(member.image).then(url => {
          //   member.infowindowImage = url
          // });

          // Reassign infowindow content on click rather than creating an infowindow for each marker
          marker.addListener('click', () => {

            this.infowindow.setContent(
              `
                <a href="${member.link}">
                  <div class="c-infowindow" style="max-width: 435px;">
                    <h3 class="c-infowindow-title" data-toggle="${this.titleToUrlTitle(member.title)}-${member.id}" style="max-width: 435px;">
                      ${member.title}
                    </h3>
                    <p style="font-style:italic; max-width: 435px;" class="${this.titleToUrlTitle(member.title)}-${member.id}">
                      <div class="hide">
                        ${this.collectAllCat(member.categories)}
                      </div>
                      ${this.categoryCollection}
                    </p>

                    ${( member.image =='' ?  ('') : `<div class="c-infowindow-image">
                      <img src="${member.image}" style="max-width: 435px; max-height: 250px; margin-bottom: 15px;" alt="${member.title}">
                    </div>`)}
                  </div>
                </a>
                <a href="${member.link}" class="button button--small">View</a>
              `
            );

            // Set the infowindow to the current marker position
            this.infowindow.setPosition(marker.getPosition());
            // Open the infowindow
            this.infowindow.open(this.map, marker);
            // let target = '#'+this.titleToUrlTitle(member.title)+'-'+member.id;
            // let targetLink = this.titleToUrlTitle(member.title);
            // let target = '#'+this.titleToUrlTitle(member.title)+'-'+member.id;
            // $(target).foundation('toggle', event);
            // console.log(targetLink);
            // window.location.href = '/vw_listing/'+targetLink+'';

            // data("target").modal("show");
          })

          return member;
        });

        var clusterStyles = [
        {
          textColor: 'white',
          url: 'https://dev.visitwaterford.ie/wp-content/themes/visitwaterford/assets/images/SVG/Cluster.svg',
          height: 67,
          width: 68,
          textSize:15,
        },
      ];

        // Assign marker clusterer
        // This basically takes 3 params, the map, the marker array, and an image or images to display
        this.markerCluster = new MarkerClusterer(this.map, this.markers, {
          imagePath: 'https://googlemaps.github.io/js-marker-clusterer/images/m',
          styles: clusterStyles
        });

        // Finally, fit the map to the map bounds
        // this.fitBounds();
      },

      clearMarkers () {
        // setMapOnAll(null);

        jQuery.each( this.markers, function( i, marker ) {

          marker.setMap(null);

        });

        this.markers = [];

        this.markerCluster.clearMarkers();

        this.markerCluster = null;
      },

      fitBounds () {
        /* eslint-disable no-undef */
        let bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        jQuery.each( this.markers, function( i, marker ) {

          var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

          bounds.extend( latlng );

        });

        if( this.markers.length == 1 ) {
          // set center of map
          this.map.setCenter( bounds.getCenter() );
          this.map.setZoom( 11 );
        }
        else {
          // fit to bounds
          this.map.fitBounds( bounds );
        }
      },

      /**
      * Convert a title to url title
      * @param {title}
      * @return {url_title}
      */
      titleToUrlTitle (title) {
        return title
        .toLowerCase()
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
      },

      collectAllCat (cat) {
        this.categoryCollection = '';
        for (var i = 0; i < cat.length; i++) {
          // console.log(write);
          let listItem = '';
          let listIndex = i+1;
          // console.log('Check i: '+listIndex+', Check length:'+cat.length);
          if (cat.length == listIndex) {
            listItem = cat[i].name+ '';
          } else {
            listItem = cat[i].name+' | ';
          }
          this.categoryCollection = this.categoryCollection + listItem
        }
      }

    }
  };
</script>

<style>
  #member-map {
    width: 100%;
    min-height: 600px;
    height: 100vh;
    max-height: calc(100vh - 250px);
  }
  .o-map-alt #member-map {
      width: 100%;
      min-height: 600px;
      height: 100vh;
      max-height: 100vh !important;
  }
  .c-infowindow-image img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/js/vue/vue-partials/gmap.vue